module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.3b79a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_hero.png
// module id = L7/i
// module chunks = 0